import TriangleDividerVertical from "../../components/triangle/triangle-divider-vertical"
import useMediaQueries from '../../hooks/useMediaQueries'
import authInfinite from "../../assets/icons/auth-infinite.svg"
import BrandLogo from "../../components/brand-logo";
// import { useLayoutEffect } from "react";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { userLogin, exchangeNodeToken } from "../../assets/api/userActions";
import {
    showLoginApiErrorSwal,
    showPhoneFormatInvalidSwal,
    showPhoneLengthInvalidSwal,
    showPhoneRequiredSwal,
    showPasswordRequiredSwal,
    showSimpleLoginErrorSwal,
} from "../../assets/utils/loginErrorSwal";
import './index.scss'
import { useEffect } from "react";

const UserLogin = () => {
    const [loginPhone, setLoginPhone] = useState("");
    const [loginPassword, setLoginPassword] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { isAbove922 } = useMediaQueries();

    const params = useParams();
    const navigate = useNavigate()


    useEffect(() => {
        const ls = localStorage.getItem("userToken");
        if (ls) {
            navigate("/quiz/join/" + params.code);
        }
    }, [navigate, params.code]);

    const onSubmitHandler = async (e) => {
        e.preventDefault();
        var regex = new RegExp('^(\\+98|0)?9\\d{9}$');

        if (!loginPhone.length) {
            showPhoneRequiredSwal();
            return;
        }
        if (loginPhone.length !== 11) {
            showPhoneLengthInvalidSwal();
            return;
        }
        if (!regex.test(loginPhone.toString())) {
            showPhoneFormatInvalidSwal();
            return;
        }
        if (!loginPassword.length) {
            showPasswordRequiredSwal();
            return;
        }

        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            const userData = await userLogin({
                phone: loginPhone,
                password: loginPassword
            });

            if (!userData) {
                showSimpleLoginErrorSwal({
                    title: "اتصال به سرور برقرار نشد",
                    detail: "در حال حاضر امکان ارتباط با سرور وجود ندارد. لطفاً اتصال اینترنت خود را بررسی و دوباره تلاش کنید.",
                    icon: "error",
                });
                return;
            }

            if (userData.customCode) {
                showLoginApiErrorSwal(userData);
                return;
            }

            const today = new Date()
            let tomorrow = new Date()
            const setExpireDate = tomorrow.setDate(today.getDate() + 1)

            let quizToken, userName, userId;
            if (userData.quizToken) {
                quizToken = userData.quizToken;
                userName = userData.name;
                userId = userData.quizUserId || userData.user_id;
            } else if (userData.token) {
                const exchangeResult = await exchangeNodeToken(userData.token);
                if (exchangeResult?.status === 'failed' || !exchangeResult?.quizToken) {
                    showLoginApiErrorSwal(exchangeResult, {
                        fallbackTitle: "ورود به آزمون انجام نشد",
                        fallbackDetail:
                            "در دریافت مجوز ورود به آزمون مشکلی پیش آمد. لطفاً پس از چند لحظه مجدداً تلاش کنید.",
                    });
                    return;
                }
                quizToken = exchangeResult.quizToken;
                userName = exchangeResult.user_name;
                userId = exchangeResult.user_id;
            } else {
                showSimpleLoginErrorSwal({
                    title: "ورود انجام نشد",
                    detail:
                        "پاسخ معتبری از سرور دریافت نشد. اگر این مشکل ادامه داشت، لطفاً به برگزارکنندهٔ آزمون اطلاع دهید.",
                    icon: "error",
                });
                return;
            }

            localStorage.setItem("userToken", JSON.stringify({
                user_id: userId,
                name: userName,
                quizToken: quizToken,
                expireDate: setExpireDate
            }))
            navigate("/quiz/join/"+params.code)
        } finally {
            setIsSubmitting(false);
        }
    }

    function renderSvgBox() {
        if (isAbove922) {
            return (
                <div className="auth-page__svg-box">
                    <object
                        type="image/svg+xml"
                        data={authInfinite}
                        width="523"
                        height="308"
                    >
                        عکس متحرک
                    </object>
                    <BrandLogo width="128" height="39" className="auth-page__brand-logo" />
                </div>
            );
        }
    }

    return (
        <main className="auth-page">
            {renderSvgBox()}
            <section className="auth-page__content">
                <TriangleDividerVertical />
                <div className="auth-page__form-container">
                    <div className="auth-page--center">
                        
                        <form
                            onSubmit={onSubmitHandler}
                            className="form-login"
                        >
                            <h4 className="login-title">ورود</h4>
                            <p className="login-description">لطفا وارد حساب کاربری خود شوید</p>
                            <input
                                type="number"
                                className="input-style"
                                placeholder="شماره تلفن همراه"
                                onChange={(e) => {
                                    setLoginPhone(e.target.value);
                                }}
                            />
                            <input
                                type="password"
                                className="input-style"
                                placeholder="رمز عبور"
                                onChange={(e) => {
                                    setLoginPassword(e.target.value);
                                }}
                            />
                            <Link to="/auth/forget-password" className="link-login">
                                فراموشی رمز عبور
                            </Link>
                            <button
                                type="submit"
                                className={`button-login ${isSubmitting ? "button-login--loading" : ""}`}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? "در حال ورود..." : "ورود"}
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </main>
    )
}

export default UserLogin